import { Box } from "@mui/material";

import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { AccountsandFinanceurl } from "../../../../config";
import { AccountTypesColumns } from "../../../../data/DynamicTable/Collumns";
import {
  allAccountCategories,
  allAccountSubCategories,
  allAccountTypes,
} from "../../../../data/Axios/queries";
import {
DebtorsListColumns,
} from "../../../../data/DynamicTable/AccountsColumns";
import DebtorsForm from "./form";
const base_url = AccountsandFinanceurl.uri;
const actions = {
  entity: "Account Subcategory",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
};
function DebtorsListTable() {
  return (
    <Box m="2px">
      <DynamicTable
        title="Debtors list"
        subtitle="Create, view or edit debtors list"
        columns={DebtorsListColumns}
        FormComponent={DebtorsForm}
        query={allAccountSubCategories}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default DebtorsListTable;
